// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const BankAbsolutPure = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="77" viewBox="0 0 34 77">
    <g fill="#FFF" fillRule="evenodd" opacity=".2">
      <path d="M4 23l12 10v24L4 47zM31.778.737l1.414 15.556-16.97 16.97-1.414-15.556zM.737 59.222l15.556-1.414 16.97 16.97-15.556 1.414z" />
    </g>
  </svg>,
);

export const BankAbsolutIcon: React.SFC<{ iconClassName?: string; style?: React.CSSProperties }> = props => (
  <BankAbsolutPure className={props.iconClassName} style={props.style} />
);

BankAbsolutIcon.displayName = 'BankAbsolutIcon';
